module.exports = __webpack_public_path__ + "img/9a.bde55486.svg";